var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"robo-galaxy-video-section"},[_c('video',{staticClass:"video",attrs:{"muted":"","autoplay":"","playsinline":"","x-webkit-playsinline":"","x5-playsinline":"","loop":"","src":"http://ad4-static.lotuscars.com.cn/webapp/pc/video/galaxy/robo_galaxy.mp4","type":"video/mp4"},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }